import axios from "axios";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import { EventRegistrationStatus } from "interfaces/events";
import { useEffect, useState } from "react";
import { LABELS_PER_STATUS } from "containers/FrontPage/HeroSection/EventCard/EventStatusBadge/constants";
import { COLORS_PER_STATUS } from "./constants";
import { EventStatusText } from "./style";

interface Props {
  eventId: number;
}

const EventStatus: React.FC<Props> = ({ eventId }) => {
  const [eventStatus, setEventStatus] = useState<EventRegistrationStatus>();
  const { currentUser } = useLoginContext();
  useEffect(
    function getEventStatus() {
      if (currentUser?.id)
        axios.get(`/events/${eventId}/registration_status/`).then(response => setEventStatus(response.data));
    },
    [currentUser?.id, eventId]
  );
  if (!currentUser) return <EventStatusText color="#b4b6b8">Logg inn for å se arrangementsstatus</EventStatusText>;
  if (!eventStatus) return <p style={{ height: "1em" }} />;
  return <EventStatusText color={COLORS_PER_STATUS[eventStatus]}>{LABELS_PER_STATUS[eventStatus]}</EventStatusText>;
};

export default EventStatus;
